module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "results-box"
  }, _vm._l((_vm.results.data), function(item, index) {
    return _c('div', {
      staticClass: "result"
    }, [_c('a', {
      staticClass: "result_title",
      attrs: {
        "href": item.webUrl,
        "target": "_blank"
      },
      domProps: {
        "innerHTML": _vm._s(item.webTitleFormat)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "result_content",
      domProps: {
        "innerHTML": _vm._s(item.webContentFormat)
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "result_link",
      attrs: {
        "href": item.webUrl,
        "target": "_blank"
      }
    }, [_vm._v("\n      " + _vm._s(item.showUrl) + "\n    ")]), _vm._v(" "), (!item.hasAction) ? _c('div', {
      staticClass: "result_saved_button"
    }, [_vm._v(_vm._s(item.statusDesc))]) : _vm._e(), _vm._v(" "), (item.hasAction) ? _c('div', {
      staticClass: "result_save_button",
      on: {
        "click": function($event) {
          _vm.saveEvidence(index)
        }
      }
    }, [_vm._v("存证")]) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ab351fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/results/TextResults.vue
// module id = 750
// module chunks = 1